import { _request,APIBaseResponse, APIMethod } from '..';
import { RequestParamsBase } from '../Models/CommonRequestModels';

const TENANTS_PATH_PREFIX = '/tenants';
const CLAIM_ROLE_PATH_PREFIX = 'roleclaimmemberships';

type APIClaimRoleMembershipListParams = RequestParamsBase & {
    tenantId: string;
    claimId: string;
}

export type ClaimRoleMembership = {
    claimDataTypeId: string;
    claimDataTypeName: string;
    claimId: string;
    claimName: string;
    claimValue: string;
    roleId: string;
    roleName: string;
}

type APIClaimRoleMembershipListResponse = APIBaseResponse<
    Array<ClaimRoleMembership>
>

export type APIClaimRoleMembershipPostParams = {
    tenantId: string;
    roleId: string;
    claimId: string;
    claimValue: string;
}
export type APIClaimRoleMembershipPostResponse = APIBaseResponse<string>;

export type APIClaimRoleMembershipPutParams = {
    tenantId: string;
    roleId: string;
    claimId: string;
    claimValue: string;
}

export type APIClaimRoleMembershipPutResponse = APIBaseResponse<string>;

type APIRoleClaimMembershipDeleteParams = {
    tenantId: string;
    roleId: string;
    claimId: string;
}

export const APIClaimRoleMembershipGetList: APIMethod<APIClaimRoleMembershipListParams, APIClaimRoleMembershipListResponse> = params => (
    _request('GET', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${CLAIM_ROLE_PATH_PREFIX}?claimId=${params.claimId}`, undefined, params.signal)
);

export const APIClaimRoleMembershipPost: APIMethod<APIClaimRoleMembershipPostParams, APIClaimRoleMembershipPostResponse> = (params) => (
    _request('POST', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${CLAIM_ROLE_PATH_PREFIX}`, params)
);

export const APIClaimRoleMembershipPut: APIMethod<APIClaimRoleMembershipPutParams, APIClaimRoleMembershipPutResponse> = (params) => (
    _request('PUT', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${CLAIM_ROLE_PATH_PREFIX}`, params)
);

export const APIClaimRoleMembershipDelete: APIMethod<APIRoleClaimMembershipDeleteParams, APIBaseResponse> = (params: APIRoleClaimMembershipDeleteParams) => (
    _request('DELETE', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${CLAIM_ROLE_PATH_PREFIX}?roleId=${params.roleId}&claimId=${params.claimId}`)
);
